import { useToastStore } from '@/stores/toastStore'
import React from 'react'
import Toast from './Toast'

const ToastContainer: React.FC = () => {
  const { toast, hideToast } = useToastStore()

  if (!toast) return null

  return <Toast toast={toast} onClose={hideToast} />
}

export default ToastContainer
